// src/modules/coding-opportunities3/IAsystem/utils/safeJson.js


export function safeJsonParse(raw) {
  if (!raw || typeof raw !== "string") {
    throw new Error("Empty AI response");
  }

  // Remove ```json ``` or ```
  let cleaned = raw
    .trim()
    .replace(/^```json/i, "")
    .replace(/^```/i, "")
    .replace(/```$/i, "")
    .trim();

  // Trim everything before the first {
  const firstBrace = cleaned.indexOf("{");
  if (firstBrace > 0) {
    cleaned = cleaned.slice(firstBrace);
  }

  // Trim everything after the last }
  const lastBrace = cleaned.lastIndexOf("}");
  if (lastBrace !== -1) {
    cleaned = cleaned.slice(0, lastBrace + 1);
  }

  try {
    return JSON.parse(cleaned);
  } catch (err) {
    console.error("❌ JSON PARSE FAILED");
    console.error("CLEANED >>>", cleaned);
    throw err;
  }
}
